import HomeHeader from "modules/home-header"

interface Props {
  account: string
}

export default function AlphaTheoryHeader({ account }: Props) {
  return <HomeHeader account={account} title="Alpha Theory Application" />
}
